export default "__VITE_ASSET__Df4VWJ$G__"